import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../../../Common/PlaceholderWrapper";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import PopupWrapper from "../../../Common/PopupWrapper";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import ScheduleChangeRequestEdit from "./ScheduleChangeRequestEdit";
import {scheduleChangeRequestActions} from "./ScheduleChangeRequestList";
import DrawAttribute from "@mnjsplatform/components/lib/common/GridView/DrawAttributeProvider";
import MnTooltipIcon from "../../../Common/MnTooltipIcon";
import i18next from "i18next";

class ScheduleChangeRequest extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            showEditForm: false
        };
    }

    get isReadOnly() {
        return this.props.dataItem.getField("TypeStatus") > 0;
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async () => {
        try {
            await this.props.dispatch(this.props.dataItem.reset());
            await this.props.dispatch(this.props.dataItem_Rows.reset());

            await this.props.dispatch(this.props.dataItem.initialize(this.props.rowKey, {
                newItem: true, withParams: false, withStyle: true
            }));
            await this.props.dispatch(this.props.dataItem_Rows.initialize(this.props.rowKey, {
                newItem: true, withParams: false, withStyle: true
            }));
        } catch (e) {
            console.error(e);
        }
    };

    addSub = () => {
        this.setState({showEditForm: true});
    };

    onChanged = () => {
        this.props.dispatch(this.props.dataItem_Rows.refresh());
    };

    paramRender = (h) => {
        return (<>
                <div className="row">
                    <div className="col-md-12">
                        {h.lbl("DateCreate")}: {h.ed("DateCreate")}
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        {h.lbl("DateSupply")}: {h.ed("DateSupply")}
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        {h.lbl("IsCommonCmd")}: {h.ed("IsCommonCmd")}
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        {h.lbl("TypeTabCalChgReasonName")}: {h.ed("TypeTabCalChgReasonName")}
                    </div>
                </div>
            </>);
    };

    refreshForm = async () => {
        await this.props.dispatch(this.props.dataItem.refresh());
        await this.props.dispatch(this.props.dataItem_Rows.refresh());
    };

    renderButtons = () => {
        return (<div className="modal-footer text-right">
                {!this.isReadOnly && this.props.dataItem_Rows.rowsCount() > 0 &&
                    <button type="button" className="btn btn-regular -goahead" onClick={() => {
                        this.props.callActionFunc(scheduleChangeRequestActions.send, this.props.rowKey, this.refreshForm)
                    }}>
                        {i18next.t("ScheduleChangeRequest_SentToHR")}
                    </button>}
                {this.isReadOnly && <button type="button" className="btn btn-regular -goahead" onClick={() => {
                    this.props.callActionFunc(scheduleChangeRequestActions.return, this.props.rowKey, this.refreshForm)
                }}>
                    {i18next.t("ScheduleChangeRequest_ReturnFromHR")}
                </button>}
                {this.isReadOnly && <button className="btn btn-regular -goahead" onClick={() => {
                    this.props.callActionFunc(scheduleChangeRequestActions.getEmail, this.props.rowKey)
                }}>
                    {i18next.t("ScheduleChangeRequest_SendExcelToEmail")}
                </button>}
                {!this.isReadOnly && <button type="button" className="btn btn-regular" onClick={() => {
                    this.props.callActionFunc(scheduleChangeRequestActions.delete, this.props.rowKey)
                }}>
                    {i18next.t("ScheduleChangeRequest_DeleteRequest")}
                </button>}
            </div>);
    };

    renderRowsGridCellEx = (cellParams) => {
        if (cellParams.fieldInfo.Name === "TabNum") {
            let tooltipText = DrawAttribute.cellTooltipProvider(cellParams.dataItem, cellParams.rowIndex, cellParams.fieldInfo);
            return (<>
                    {cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex)}
                    <MnTooltipIcon text={tooltipText} iconClass="fa fa-info-circle ml-2 gridcell-tooltip"/>
                </>);
        }

        return cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex);
    };

    render() {
        return (<>
                <PopupWrapper popupVisible={true} title={i18next.t("ScheduleChangeRequest_ChangeRequestTitle")}
                              instructionId="ScheduleChangeRequest"
                              onClose={this.props.onClose} renderButtons={this.renderButtons}>
                    <PlaceholderWrapper placeholderId="ScheduleChangeRequest_10" collapsed={false} showSplitterLine={false}
                                        canCollapse={false}
                                        title={<><i className='fa fa-info-circle'/> {i18next.t("Designations")}</>}
                                        staticTitle={`${i18next.t("ScheduleChangeRequest_ChangeRequestTitle")} - ${i18next.t("Designations")?.toLocaleLowerCase()}`}
                    >
                        <div className="row">
                            <div className="col-md-6 text-center" style={{backgroundColor: 'rgb(204, 255, 255)'}}>
                                <span>{i18next.t("ScheduleChangeRequest_NewRequestLine")}</span>
                            </div>

                            <div className="col-md-6 text-center" style={{color: 'red'}}>
                                <span>{i18next.t("ScheduleChangeRequest_SendRequestError")}</span>
                            </div>
                        </div>
                    </PlaceholderWrapper>

                    <PlaceholderWrapper placeholderId="ScheduleChangeRequest_20" collapsed={false} showSplitterLine={false}
                                        staticTitle={`${i18next.t("ScheduleChangeRequest_ChangeRequestTitle")} - ${i18next.t("Common")?.toLocaleLowerCase()}`}
                                        canCollapse={false} showHeaderTitle={false}>
                        <ComplexParam dataItem={this.props.dataItem}
                                      showApplyButton={false} showSearchBar={false}
                                      renderParams={this.paramRender}
                        />
                    </PlaceholderWrapper>

                    <PlaceholderWrapper placeholderId="ScheduleChangeRequest_30" collapsed={false} showSplitterLine={false}
                                        staticTitle={`${i18next.t("ScheduleChangeRequest_ChangeRequestTitle")} - ${i18next.t("Employees")?.toLocaleLowerCase()}`}
                                        canCollapse={false} showHeaderTitle={false}>
                        {!this.isReadOnly && <button className="btn btn-regular -goahead"
                                                     onClick={this.addSub}>{i18next.t("ScheduleChangeRequest_AddEmployees")}</button>}
                        <GridView dataItem={this.props.dataItem_Rows}
                                  allowPagination={true}
                                  useItemStyle={true}
                                  readOnly={this.isReadOnly}
                                  renderCellEx={this.renderRowsGridCellEx}
                        />
                    </PlaceholderWrapper>
                </PopupWrapper>

                {this.state.showEditForm && <ScheduleChangeRequestEdit rowKey={this.props.rowKey}
                                                                       onClose={() => {
                                                                           this.setState({showEditForm: false})
                                                                       }}
                                                                       afterSave={this.onChanged}
                />}
            </>);
    }
}

ScheduleChangeRequest.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem: PropTypes.object,
    dataItem_Rows: PropTypes.object,
    rowKey: PropTypes.object.isRequired,
    onClose: PropTypes.func,
    callActionFunc: PropTypes.func
};

ScheduleChangeRequest.defaultProps = {
    onClose: () => {
    }, callActionFunc: () => {
    }
};

function mapStateToProps(state, ownProps) {
    return {
        dataItem: state.subScheduleChangeState.VacancyCmdChTabCal_Desc,
        dataItem_Rows: state.subScheduleChangeState.VacancyCmdChTabCalPers_List
    }
}

export default connect(mapStateToProps)(ScheduleChangeRequest);